/**
 * @title Login page
 * @description The login page, where consumers will write their email to get access to their retrade area
 * @image https://storageaccountourimbea2.blob.core.windows.net/tradein2guide/frontpage-login.png
 */
import React, {FC} from "react";
import {PublicRenderer} from "./PublicRenderer";
import {makeStyles} from "@mui/styles";
import {StyledButton, StyledDiv, StyledTypography} from "../../providers/layout/LayoutProvider";
import {useNavigate} from "react-router-dom";
import {PublicPagePath} from "./PublicPage";
import {useRecoilValue} from "recoil";
import {AppDataAtom} from "../../providers/access/ApplicationDataProvider";
import {AccessContextData} from "../../providers/access/AppContextProvider";
import {AccessForm} from "./AccessForm";
import {LocalizationsAtom} from "../../providers/localization/LocalizationProvider";

export const LoginPagePath = () => {
   return "/login"
}
export const LoginPage: FC<any> = () => {
   const localizations = useRecoilValue(LocalizationsAtom);
   const appData = useRecoilValue(AppDataAtom);
   const appContext = useRecoilValue(AccessContextData);

   let showLoginOptions = appData.wholeSaleActive && !appContext.disableLogin;

   const classes = useStyles();
   const navigate = useNavigate();

   const onBack = () => {
      navigate(PublicPagePath())
   }

   return <PublicRenderer>
      {!window.loginMode && <StyledTypography variant={"h1"} type={"front"}
                        style={{marginBottom: '26px'}}>{localizations.loginPageTitle}
      </StyledTypography>}
      {!window.loginMode && <StyledTypography variant={"body1"} type={"front"} style={{marginBottom: '20px'}}>
         {localizations.loginPageDescription}<br/>
         {localizations.loginPageDescription2}
      </StyledTypography>}
      {(!window.loginMode && localizations.loginPageDescription3) && <StyledTypography variant={"body1"} type={"front"} style={{marginBottom: '20px'}}>
         {localizations.loginPageDescription3}
      </StyledTypography>}
      <AccessForm/>
      {(!window.loginMode && showLoginOptions) && <StyledDiv type={"front"} className={classes.backContainer}>
         <StyledButton styletype={"main"} onClick={onBack}>{localizations.loginPageBack}</StyledButton>
      </StyledDiv>}
   </PublicRenderer>
}
const useStyles = makeStyles({
   backContainer: {
      marginTop: '20px'
   }
})

